module.exports = __webpack_public_path__ + "static/media/united-kingdom.e5564902.svg";